export default [
  {
    title: 'Thapar University',
    subtitle: 'Bachelor of Engineering',
    date: 'July 2018',
    paragraphs: [
      'Specialisation: Computer Engineering',
      'Electives: Web Design, NLP, Deep Learning, Big Data Analytics and Business Intelligence'
    ]
  },
  {
    title: "St. Joseph's College",
    subtitle: 'Intermediate',
    date: '2013',
    paragraphs: ['ISC Board Examinations', 'Majors: PCM with Computer Science']
  },
  {
    title: "St. Joseph's College",
    subtitle: 'High School',
    date: '2011',
    paragraphs: ['ICSE Board Examinations', 'Majors: Computer Application']
  }
];
